import React, { lazy, Suspense } from "react";
import ExecutionEnvironment from "exenv";
import CustomMeta from "../components/CustomMeta/CustomMeta";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { makeStyles } from "tss-react/mui";
import { Typography } from "@mui/material";

const BlogGeneratorDashboard = lazy(() =>
  import(
    /* webpackChunkName: "BlogGeneratorDashboard" */ "../components/BlogGenerator/BlogGeneratorDashboard"
  )
);

const useStyles = makeStyles()((theme) => ({
  fullPageHeight: {
    minHeight: "100vh",
    width: "100%",
    backgroundColor: "#f8f9fa",
  },
  headerSection: {
    backgroundColor: "white",
    borderBottom: "1px solid #e0e0e0",
    padding: theme.spacing(2, 0),
  },
  headerContent: {
    width: "100%",
    maxWidth: 1400,
    margin: "0 auto",
    padding: theme.spacing(0, 3),
    boxSizing: "border-box",
  },
  mainDiv: {
    width: "100%",
    maxWidth: 1400,
    margin: "0 auto",
    padding: theme.spacing(0, 3),
    boxSizing: "border-box",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(0, 2),
    },
  },
}));

function blogGeneratorDashboard(props) {
  const { classes } = useStyles();
  const authenticated =
    props.user.authenticated && !props.user.loading;

  return (
    <div className={classes.fullPageHeight}>
      <CustomMeta
        title="Blog Generator Dashboard - Content Generator"
        description="Manage your WordPress blog generator — settings, keywords, and publishing calendar."
        url="https://contentgenerator.io/blog-generator/dashboard"
      />
      {authenticated && (
        <div className={classes.headerSection}>
          <div className={classes.headerContent}>
            <Typography variant="body2" color="textSecondary">
              AI-powered WordPress blog automation
            </Typography>
          </div>
        </div>
      )}
      <div className={classes.mainDiv}>
        {ExecutionEnvironment.canUseDOM && (
          <Suspense fallback={<div />}>
            <BlogGeneratorDashboard user={props.user} />
          </Suspense>
        )}
      </div>
    </div>
  );
}

blogGeneratorDashboard.propTypes = {
  user: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps)(blogGeneratorDashboard);
